import { registerPageInit } from '../barba/page-init-registry';
import '../../css/_root.scss';
import '../../css/pages/politica/politica.scss';

class Politica {
  constructor() {}

  public init(): void {
    this.bindEvents();
  }

  private bindEvents(): void {}
}

registerPageInit('politika', () => {
  const page = new Politica();
  page.init();
});
